<!-- 教育局-课程评价统计 -->
<template>
  <div>
    <div class="index" v-show="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
         <div class="time">
          <span>截止日期:{{dayjs(new Date().getTime()-86400000).format('YYYY-MM-DD')}}</span>
        </div>
      </div>
      <header>
        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>课程评价分布情况</span>
          </div>
          <div id="echarts-box1"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>学校课程平均评价TOP5</span>
          </div>
          <div id="echarts-box2"></div>
        </div>

        <div class="header-item">
          <div class="header-item-title">
            <span class="circle"></span>
            <span>机构课程平均评价TOP5</span>
          </div>

          <div id="echarts-box3"></div>
        </div>
      </header>

      <div>
        <el-form :inline="true" :model="queryParams" label-width="70px">
          <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              clearable
              placeholder="选择学年学期"
              class="label"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="queryParams.source"
              clearable
              placeholder="选择区域"
              class="label"
            >
              <el-option
                v-for="item in sourceList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input placeholder="请输入机构名称"></el-input>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="a" label="课程名称" align="center">
            </el-table-column>
            <el-table-column prop="b" label="所属单位" align="center">
            </el-table-column>
            <el-table-column prop="c" label="课程分类" align="center">
            </el-table-column>
            <el-table-column prop="d" label="课程评价" align="center">
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="toDetail(scope.row)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <Detail
      :info="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
    ></Detail>
  </div>
</template>
<script>
import {
  handleCurriculumEvaluation,
  handleCurriculumEvaluationSchool,
  handleCurriculumListMechanism,
} from "@/api/education/statistical.js";
import dayjs from "dayjs";
import * as echarts from "echarts";
import util from '@/utils/util.js';
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        source: "",
        teacher: "",
        name: "",
      },
      sourceList: [],
      semesterList: [
        { id: "xq1", label: "2021~2022年度下学期" },
        { id: "xq2", label: "2021~2022年度上学期" },
        { id: "xq3", label: "2020~2021年度下学期" },
        { id: "xq4", label: "2020~2021年度上学期" },
        { id: "xq5", label: "2019~2020年度下学期" },
        { id: "xq6", label: "2019~2020年度上学期" },
      ],
      tableData: [
        { a: "世界百科", b: "实验小学", c: "科普", d: "5星（2452）" },
        { a: "科学", b: "实验小学", c: "科普", d: "5星（1298）" },
        { a: "阅读", b: "第七小学", c: "阅读", d: "4.5星（2152）" },
        { a: "美术", b: "第二实验小学", c: "艺术", d: "5星（1552）" },
        { a: "体适能", b: "第一小学", c: "文体", d: "5星（2332）" },
        { a: "高分速读", b: "欧美思", c: "阅读", d: "4.5星（2882）" },
        { a: "荔壳记忆", b: "智课教育", c: "科普", d: "5星（3452）" },
        {
          a: "海滨少儿美术",
          b: "清华艺科创新院美育中心	",
          c: "艺术",
          d: "5星（2332）",
        },
        { a: "兴墨书法", b: "欧美思", c: "艺术", d: "4.5星（2882）" },
        { a: "傲未来少儿编程", b: "欧美思", c: "科普", d: "5星（3452）" },
      ],
      detail: {
        info: {},
        show: false,
      },
      school_info: JSON.parse(sessionStorage.getItem("classList")),
      // semesterArr: JSON.parse(sessionStorage.getItem("semesterList")) || [],
      dateTime: "",
      educationType: sessionStorage.getItem("educationType") === "area",
      Userlist: JSON.parse(window.sessionStorage.getItem("Userlist")),
      curriculumEvaluationData: [
        { value: 0, name: "5星" },
        { value: 0, name: "4星及以上" },
        { value: 0, name: "3星及以上" },
        { value: 0, name: "2星及以上" },
        { value: 0, name: "1星及以上" },
      ],
      curriculumEvaluationSchoolData: {
        data: [],
        value: [],
      },
      curricurriculumListMechanism: {
        data: [],
        value: [],
      },
    };
  },
  watch: {
    "queryParams.source": function (n, o) {
      this.queryParams.teacher = "";
      this.teacherList = [];
      // this.gradeList = this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
  },
  mounted() {
    this.init();
    this.getData();
  },
  created() {
    // this.campusList = this.school_info?.slice() || [];
  },
  methods: {
    dayjs,
    async getData() {
      this.getNowDate();
      this.getCurriculumEvaluation();
      this.getCurriculumEvaluationSchool();
      this.getCurriculumListMechanism();
    },
    async getCurriculumEvaluation() {
      try {
        let params = {
          date: this.dateTime, //统计日期,//必填
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          platform_code: sessionStorage.getItem("platformCode"), //必填
          school_year: "2021-2022", //必填
          term: "2", //必填
        };
        let { code, data } = await handleCurriculumEvaluation(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            for (let key in data.rows[0]) {
              this.curriculumEvaluationData.forEach((it) => {
                if (key == "r1" && it.name == "1星及以上") {
                  it.value = data.rows[0][key];
                } else if (key == "r2" && it.name == "2星及以上") {
                  it.value = data.rows[0][key];
                } else if (key == "r3" && it.name == "3星及以上") {
                  it.value = data.rows[0][key];
                } else if (key == "r4" && it.name == "4星及以上") {
                  it.value = data.rows[0][key];
                } else if (key == "r5" && it.name == "5星") {
                  it.value = data.rows[0][key];
                }
              });
            }
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getCurriculumEvaluationSchool() {
      try {
        let params = {
          date: this.dateTime, //统计日期,//必填
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          platform_code: sessionStorage.getItem("platformCode"), //必填
          school_year: "2021-2022", //必填
          term: "2", //必填
        };
        let { code, data } = await handleCurriculumEvaluationSchool(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            data.rows.forEach((it) => {
              this.curriculumEvaluationSchoolData.data.push(it.avg_rating);
              this.curriculumEvaluationSchoolData.value.push(
                it.eval_user_organame
              );
            });
          } else {
            this.curriculumEvaluationSchoolData = {
              data: [0],
              value: ["无"],
            };
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    async getCurriculumListMechanism() {
      try {
        let params = {
          date: this.dateTime, //统计日期,//必填
          coun_code: this.Userlist.area_code,
          prov_code: this.Userlist.province_code,
          city_code: this.Userlist.city_code,
          platform_code: sessionStorage.getItem("platformCode"), //必填
          school_year: "2021-2022", //必填
          term: "2", //必填
        };
        let { code, data } = await handleCurriculumListMechanism(params);
        if (code === "0") {
          if (data.rows && data.rows.length != 0) {
            data.rows.forEach((it) => {
              this.curricurriculumListMechanism.data.push(it.avg_rating);
              this.curricurriculumListMechanism.value.push(it.orga_name);
            });
          } else {
            this.curricurriculumListMechanism = {
              data: [0],
              value: ["无"],
            };
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.init();
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getData();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getData();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getData();
    },
    toDetail(item) {
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
    // 获取当前一天的数据
    getNowDate() {
      this.dateTime = util.getNowDate();
    },
    init() {
      let vm = this;
      this.$nextTick(() => {
        // 圆环图
        let chartDom1 = document.getElementById("echarts-box1");
        let myChart = echarts.init(chartDom1);
        let option = {
          tooltip: {
            trigger: "item",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          legend: {
            // data: [],
            // orient: 'vertical',
            left: "center",
            top: "bottom",
            icon: "circle",
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["38%", "50%"], // 这个属性修改环形宽度
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 0,
                borderColor: "#fff",
                borderWidth: 0,
              },
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: "16",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: this.curriculumEvaluationData,
            },
          ],
          // 圆环颜色
          color: ["#5BB0FF", "#51D6A6", "#EFD051", "#F27676", "#757FFD"],
        };
        myChart.setOption(option);

        // 柱状图
        let chartDom2 = document.getElementById("echarts-box2");
        let myChart2 = echarts.init(chartDom2);
        let option2 = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
             formatter: '<strong>{b0}</strong> <br /> <span style="display: inline-block; margin-right: 4px; border-radius: 10px; width: 10px; height: 10px;background-color: #5BB0FF;"></span> 平均评价数：<strong>{c0}</strong> <br />'
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: this.curriculumEvaluationSchoolData.value,
            // splitLine: {show: false},//去除网格分割线
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 4; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: this.curriculumEvaluationSchoolData.data,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    // { offset: 0, color: '#009DFD' },
                    { offset: 1, color: "#5BB0FF" },
                  ]),
                  // barBorderRadius: 16, // 柱子圆角, 单位为px
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart2.setOption(option2);

        // 柱状图
        let chartDom3 = document.getElementById("echarts-box3");
        let myChart3 = echarts.init(chartDom3);
        let option3 = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
             formatter: '<strong>{b0}</strong> <br /> <span style="display: inline-block; margin-right: 4px; border-radius: 10px; width: 10px; height: 10px;background-color: #51D6A6;"></span> 平均评价数：<strong>{c0}</strong> <br />'
          },
          grid: {
            height: 200,
            top: 30,
            left: 42,
          },
          xAxis: {
            type: "category",
            data: this.curricurriculumListMechanism.value,
            axisLine: {
              //坐标线
              lineStyle: {
                type: "solid",
                color: "#DDDDDD", //轴线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#999999", //坐标值的具体的颜色
              },
              formatter: function (params) {
                var newParamsName = ""; // 最终拼接成的字符串
                var paramsNameNumber = params.length; // 实际标签的个数
                var provideNumber = 4; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                /**
                 * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                 */
                // 条件等同于rowNumber>1
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr; // 最终拼成的字符串
                  }
                } else {
                  // 将旧标签的值赋给新标签
                  newParamsName = params;
                }
                //将最终的字符串返回
                return newParamsName;
              },
            },
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: this.curricurriculumListMechanism.data,
              type: "bar",
              showBackground: true,
              backgroundStyle: {
                // 背景颜色
                color: "none", //'#E8F6FF'
              },
              itemStyle: {
                // 柱子颜色
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 1, color: "#51D6A6" },
                  ]),
                  label: {
                    formatter: "{c}",
                    show: true,
                    position: "top",
                    textStyle: {
                      fontSize: "12",
                      color: "#999999",
                    },
                  },
                },
              },
              barWidth: 20, //设置柱子宽度，单位为px
            },
          ],
        };
        myChart3.setOption(option3);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
    .time {
      font-weight: normal;
      margin-left: 67%;
      color: #606266;
      font-size: 14px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
header {
  width: 100%;
  height: 350px;
  display: flex;
  .header-item {
    width: 33%;
    .header-item-title {
      font-size: 18px;
      color: #333;
      display: flex;
      align-items: center;
      .circle {
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #4991e1;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .header-item-text {
      font-size: 14px;
      color: #666;
      padding-left: 20px;
      margin-top: 5px;
    }
  }
  #echarts-box1 {
    width: 280px;
    height: 280px;
  }
  #echarts-box2,
  #echarts-box3 {
    width: 300px;
    height: 280px;
  }
}
</style>
